import { FC, useState, useEffect } from 'react'
import cn from 'clsx'
import s from './Navbar.module.css'
import { useBreakpoints } from 'hooks/useTailwindBreakpoints'

const NavbarRoot: FC = ({ children }) => {
  const [prevScrollPos, setPrevScrollPos] = useState(0)
  const [isVisible, setIsVisible] = useState(true)
  const [isFixed, setIsFixed] = useState(false)
  const [animate, setAnimate] = useState(false)
  const [hideTopNav, setHideTopNav] = useState(false)
  
  const {md: md} = useBreakpoints()
  const [navHeight, setNavHeight] = useState<number>(220)

  // The navHeight value is used in the handleScroll event
  useEffect(() => {
    if (md) {
      setNavHeight(220)
    }else {
      setNavHeight(132)
    }
  }, [md])

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY

      if (currentScrollPos > prevScrollPos) {
        // Scroll down
        if (currentScrollPos > navHeight) {
          setIsFixed(true)
          setIsVisible(false)
          setHideTopNav(false)
        }
      } else {
        // Scroll up
        setAnimate(true)
        setIsVisible(true)
        setHideTopNav(true)

        if (currentScrollPos === 0) {
          setIsFixed(false)
        }

        if (currentScrollPos <= 32) {
          setHideTopNav(false)
          setAnimate(false)
        }
      }
      setPrevScrollPos(currentScrollPos)
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [navHeight, prevScrollPos])

  return (
    <header
      className={cn(
        s.root,
        { [s.hide]: !isVisible },
        { [s.stick]: isFixed },
        { [s.animate]: animate },
        { [s.hideTop]: hideTopNav }
      )}
    >
      {children}
    </header>
  )
}

export default NavbarRoot
